import { queryOptions } from "@tanstack/react-query";
import { CustomerwebSchemas } from "api-types";
import { axiosClient } from "auth-sdk";

import { ENDPOINTS } from "../common/constants";

export const RECONNECT_REQUIRED_QUERY_KEY = "reconnect-required";

export const getReconnectRequiredQueryOptions = (customerDomain: string) => {
  const url = ENDPOINTS.RECONNECT_REQUIRED.replace(":customerSlug", customerDomain);

  return queryOptions({
    queryKey: [RECONNECT_REQUIRED_QUERY_KEY, customerDomain],
    queryFn: () => axiosClient.get<CustomerwebSchemas.SettingsReconnectRequiredResponse>(url),
    select: ({ data }) => data,
    refetchOnMount: true,
  });
};
